import mixpanel from "mixpanel-browser";

import { AppListenerMiddleware } from "@src/store";
import { createWidget, editWidget } from "@src/store/slices/widgets";

export function setupMixPanelListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: createWidget,
    effect: (action) => {
      mixpanel.track("click_create_widget_button", {
        widget_type: action.payload,
      });
    },
  });
  middleware.startListening({
    actionCreator: editWidget,
    effect: (action) => {
      mixpanel.track("click_edit_widget_button", {
        widget_type: action.payload.widgetType,
      });
    },
  });
}
